export default __webpack_public_path__ + "static/media/Gildan 64000 blanc (front) (transparent)(fond blanc).d5058de9.png";